import { render, staticRenderFns } from "./vendors.vue?vue&type=template&id=68d8ad4b&scoped=true"
import script from "./vendors.vue?vue&type=script&lang=js"
export * from "./vendors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d8ad4b",
  null
  
)

export default component.exports